import { Component, ReactNode } from 'react';
import { Navigate } from 'react-router';
import { UserRole } from '@synergy/models';
import { connect } from 'react-redux';
import { hasRole } from '@synergy/utils';

import { AppState } from '../../../store/models/app-state';
import { User } from '../../models/user';

interface AccessControlReduxProps {
    user: User;
}

interface AccessControlOwnProps {
    allowedRoles?: UserRole | UserRole[];
    redirect?: boolean;
    children?: ReactNode;
}

class AccessControlBase extends Component<AccessControlOwnProps & AccessControlReduxProps> {
    public override render() {
        const { user, allowedRoles, redirect, children } = this.props;

        const allowedByRoles = !(allowedRoles && allowedRoles.length > 0) || hasRole(allowedRoles, user);
        const allowed = allowedByRoles;

        if (allowed) {
            return children;
        }

        if (redirect) {
            return <Navigate to="/demands" />;
        }
        return null;
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user,
});

export const AccessControl = connect(mapStateToProps)(AccessControlBase);
